<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container-fluid">
    <div class="col-sm-12 text-left">
      <h3>
        <router-link to="/manuais">Manuais</router-link> » <router-link to="/manual/c/0">Adicionar</router-link>
      </h3>
    </div>
    <div class="row">
    <template v-for="item,key in manuais">
      <div class="col-sm-4 text-left">
        <div>
          <h4>{{ key }}</h4>
          <template v-for="m in item">
            <a @click.prevent="select4catsubcat(m.cat,m.subcat)">{{ m.cat }} » {{ m.subcat }}</a><b class="text-muted"> ( {{ m.qtd }} )</b><br>
          </template>
        </div>
      </div>
    </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'manuallist',
    data () {
      return {
        loading: false,
        manuais: []
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getmanual.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.status) {
              this.manuais = response.body.rows
            } else {
              this.manuais = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      select4edit (cod) {
        this.$router.push({path: `/manual/u/${cod}`})
      },
      select4catsubcat (cat, subcat) {
        this.$router.push({path: '/manuais/categoria', query: {c: cat, sc: subcat}})
      }
    },
    created: function () {
      this.load()
    },
    watch: {
      '$route' (to, from) {
        this.load()
      }
    }
  }
</script>

<style scoped>
    .container-fluid {
      width: 80vw;
      margin: auto;
    }
    .col-sm-4 {
      padding: 5px;
    }
    .col-sm-4 div{
      border: 1px solid #dedede;
      padding: 5px;
    }
    a.glyphicon {
      text-decoration: none;
    }
    @media(max-width: 762px) {
      .container-fluid {
        width: 100vw;
        margin: 0px;
        padding: 5px;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/ManRel.vue